
import { useState, useCallback } from 'react';
import { Sweepstakes } from '../useSweepstakesData';
import { DEFAULT_FORM_VALUES } from './useFormValues';

export const useEditMode = (setFormValues: (values: any) => void) => {
  const [isAddingNew, setIsAddingNew] = useState(false);
  const [editingSweepstakes, setEditingSweepstakes] = useState<Sweepstakes | null>(null);

  const startEdit = useCallback((sweepstake: Sweepstakes) => {
    setEditingSweepstakes(sweepstake);
    
    const startDate = new Date(sweepstake.start_date).toISOString().split('T')[0];
    const drawDate = new Date(sweepstake.draw_date).toISOString().split('T')[0];
    
    setFormValues({
      name: sweepstake.name,
      description: sweepstake.description || '',
      image_url: sweepstake.image_url || '',
      start_date: startDate,
      draw_date: drawDate,
      eligibility_criteria: sweepstake.eligibility_criteria ? {
        min_points: sweepstake.eligibility_criteria.min_points || 0,
        min_tier: sweepstake.eligibility_criteria.min_tier || 'standard',
        activity_required: sweepstake.eligibility_criteria.activity_required || false,
        activity_days: sweepstake.eligibility_criteria.activity_days || 30
      } : DEFAULT_FORM_VALUES.eligibility_criteria,
      prize_details: sweepstake.prize_details || DEFAULT_FORM_VALUES.prize_details
    });
    
    setIsAddingNew(true);
  }, [setFormValues]);

  const resetEditMode = () => {
    setIsAddingNew(false);
    setEditingSweepstakes(null);
  };

  return {
    isAddingNew,
    setIsAddingNew,
    editingSweepstakes,
    startEdit,
    resetEditMode
  };
};
